// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-dialog-container {
  position: fixed;
  top: 50%;
  left: 50%;
  opacity: 0;
  z-index: -1;
}
.modal-dialog-container.visible {
  opacity: 1;
  z-index: 50;
}
.modal-dialog-container.scrollable .modal-dialog {
  max-height: 800px;
  overflow-y: auto;
}
.modal-dialog-container.modal-lrg .modal-dialog {
  width: 775px !important;
  margin-left: -387px;
}
.modal-dialog-container.modal-xlrg .modal-dialog {
  width: 975px !important;
  margin-left: -487px;
}
.modal-dialog-container .modal-dialog {
  position: relative;
  min-height: 200px;
  width: 550px;
  margin-left: -275px;
  padding: 20px 20px 20px 30px;
  background-color: #ffffff;
  border: 3px solid #7F6C2E;
  display: block;
  margin-bottom: 0;
}
.modal-dialog-container .modal-dialog.suprise {
  margin-bottom: -10000px;
}
.modal-dialog-container .modal-dialog h2 {
  margin-top: 0;
}
.modal-dialog-container .modal-dialog .modal-body {
  padding: 0;
  margin-bottom: 34px;
}
.modal-dialog-container .modal-dialog > .close-dialog {
  position: absolute;
  top: 0;
  margin-top: 20px;
  right: 0;
  margin-right: 20px;
  height: 24px;
  width: 24px;
  background-image: url('hover-x.51d99dd21ec0e20c.svg');
  background-position: 99% 3%;
  background-repeat: no-repeat;
}
.modal-dialog-container .modal-dialog > .close-dialog:hover {
  background-image: url('unselected-x.94f7db39b7176d24.svg');
  cursor: pointer;
}
.modal-dialog-container .modal-dialog .buttons {
  display: flex;
  justify-content: flex-end;
}
.modal-dialog-container .modal-dialog .buttons button {
  text-align: center;
  margin-left: 10px;
}
.modal-dialog-container .modal-dialog .buttons .modal-buttons {
  display: flex;
}
.modal-dialog-container .modal-dialog > #final-modal-item {
  padding-bottom: 60px;
}
.modal-dialog-container .modalOverflow {
  overflow-y: scroll;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/modal/modal.component.less"],"names":[],"mappings":"AAEA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AADJ;AAGI;EACI,UAAA;EACA,WAAA;AADR;AAII;EAEQ,iBAAA;EACA,gBAAA;AAHZ;AAOI;EAEQ,uBAAA;EACA,mBAAA;AANZ;AAUI;EAEQ,uBAAA;EACA,mBAAA;AATZ;AApBA;EAkCQ,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAXR;AAaQ;EACI,uBAAA;AAXZ;AAlCA;EAiDY,aAAA;AAZZ;AArCA;EAqDY,UAAA;EACA,mBAAA;AAbZ;AAzCA;EA0DY,kBAAA;EACA,MAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qDAAA;EACA,2BAAA;EACA,4BAAA;AAdZ;AAgBY;EACI,0DAAA;EACA,eAAA;AAdhB;AAzDA;EA4EU,aAAA;EACA,yBAAA;AAhBV;AA7DA;EAgFgB,kBAAA;EACA,iBAAA;AAhBhB;AAjEA;EAqFgB,aAAA;AAjBhB;AApEA;EA0FY,oBAAA;AAnBZ;AAvEA;EA+FQ,kBAAA;AArBR","sourcesContent":["@import (reference) '../../styles/variables.less';\n\n.modal-dialog-container {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    opacity: 0;\n    z-index: -1;\n\n    &.visible {\n        opacity: 1;\n        z-index: 50;\n    }\n\n    &.scrollable {\n        .modal-dialog {\n            max-height: 800px;\n            overflow-y: auto;\n        }\n    }\n\n    &.modal-lrg {\n        .modal-dialog {\n            width: 775px !important;\n            margin-left: -387px;\n        }\n    }\n\n    &.modal-xlrg {\n        .modal-dialog {\n            width: 975px !important;\n            margin-left: -487px;\n        }\n    }\n\n    .modal-dialog {\n        position: relative;\n        min-height: 200px;\n        width: 550px;\n        margin-left: -275px;\n        padding: 20px 20px 20px 30px;\n        background-color: @white;\n        border: 3px solid @primary-base;\n        display: block;\n        margin-bottom: 0;\n\n        &.suprise {\n            margin-bottom: -10000px;\n        }\n\n        h2 {\n            margin-top: 0;\n        }\n\n        .modal-body {\n            padding: 0;\n            margin-bottom: 34px;\n        }\n\n        > .close-dialog {\n            position: absolute;\n            top: 0;\n            margin-top: 20px;\n            right: 0;\n            margin-right: 20px;\n            height: 24px;\n            width: 24px;\n            background-image: url(../../styles/img/hover-x.svg);\n            background-position: 99% 3%;\n            background-repeat: no-repeat;\n\n            &:hover {\n                background-image: url(../../styles/img/unselected-x.svg);\n                cursor: pointer;\n            }\n        }\n\n        .buttons {\n          display: flex;\n          justify-content: flex-end;\n\n            button {\n                text-align: center;\n                margin-left: 10px;\n            }\n\n            .modal-buttons {\n                display: flex;\n            }\n        }\n\n        > #final-modal-item {\n            padding-bottom: 60px;\n        }\n    }\n\n    .modalOverflow {\n        overflow-y: scroll;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
